import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Children, cloneElement, useMemo } from 'react';
import './style/tree-node.sass';
import * as classnames from 'classnames';
import { getDropType, getScaffolds } from './utils/tree-node-utils';
import { useBooleanState } from 'shared/hooks/state/boolean';
export function treeNodeRenderer(props) {
    const { children, scaffoldBlockPxWidth, lowerSiblingCounts, connectDropTarget, isOver, draggedNode, canDrop, style, show_scaffolds = true, } = props;
    const [highlight, highlightOff, highlightOn] = useBooleanState(false);
    const scaffolds = useMemo(() => getScaffolds(props), [props]);
    return (connectDropTarget(_jsx("div", { style: { marginLeft: '-15px', width: 'calc(100% + 15px)' }, children: _jsxs("div", { style: { ...style, height: '50px' }, onMouseOver: highlightOn, onMouseLeave: highlightOff, className: classnames('node', { highlight }, getDropType(!!canDrop, isOver)), children: [show_scaffolds && scaffolds, _jsx("div", { className: "nodeContent", style: {
                        paddingLeft: scaffoldBlockPxWidth * lowerSiblingCounts.length,
                    }, children: Children.map(children, (child) => cloneElement(child, {
                        isOver,
                        canDrop,
                        draggedNode,
                    })) })] }) })) ?? _jsx(_Fragment, {}));
}
